export const EntityType = {
	order: 1,
	task: 2,
};

export const resourceByEntityType = { [EntityType.task]: "tasks", [EntityType.order]: "orders" };